import Model from "@/api/Model";

class SetToggleChecked extends Model {
    buildUrl(request) {
        return ['stock/products', request.param,'toggle-checked'];
    }
};

export default new SetToggleChecked;